import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const BackpackIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescBackpackStuffing">backpack</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M101 55.1A35.8 35.8 0 0 0 65.2 91v45.6a17 17 0 0 0 17 17h37.6a17 17 0 0 0 17-17V91A35.8 35.8 0 0 0 101 55.1Z"
        className="accent"
      />
      <rect
        x="74"
        y="109.4"
        width="54"
        height="37.5"
        rx="7"
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
      <path
        d="M109.1 53.1a38 38 0 0 1 4 1.1v-1.5a7.6 7.6 0 0 0-7.5-7.5h-9.2a7.6 7.6 0 0 0-7.5 7.5v1.5a38 38 0 0 1 4-1.1v-.4a3.6 3.6 0 0 1 3.5-3.5h9.2a3.6 3.6 0 0 1 3.5 3.5Zm-53.7 6.6c1.8 1.5 5.5 5.8 8.8 17.4 1.4-4 4.8-11.7 10.6-15.8-1-1.8-4.5-7.5-10.5-5.5a38.9 38.9 0 0 0-8.9 4Zm-3.5 3.5c-.8 3.5-2.4 16.2 6.7 41.3.1.5 1.9 6.6 3.2 12l-.3-32.3s-1.3-13.8-9.6-21Zm75.3-1.9a34.6 34.6 0 0 1 10.6 15.8c3.3-11.6 7-16 8.8-17.4a38.7 38.7 0 0 0-8.9-3.9c-6-2-9.5 3.7-10.5 5.5Zm22.9 1.9c-8.3 7.2-9.6 21-9.6 21.1l-.3 32.2c1.3-5.4 3.1-11.5 3.2-12 9.2-25.2 7.5-37.8 6.7-41.3ZM78.4 122h45.2v-5.6a2.6 2.6 0 0 0-2.6-2.6H81a2.6 2.6 0 0 0-2.6 2.6Zm0 4.4V140a2.6 2.6 0 0 0 2.6 2.6h40a2.6 2.6 0 0 0 2.6-2.6v-13.6Z"
        className="accent"
      />
    </Icon>
  );
};

export default BackpackIcon;
